module.exports = __webpack_public_path__ + "img/full3-min.1662d46d.png";